module.exports = __webpack_public_path__ + "3bdc4e70b33aacda7f9fb7810566f920.svg";